import { FunctionComponent, SVGProps } from 'react'
import { CanadaFlagIcon, UsaFlagIcon } from '@/assets'
import { CURRENCY_OPTIONS } from '@/utils/constants'

/** Flag icon per currency code, mirroring the main site's currency switcher. */
const currencyFlags: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  USD: UsaFlagIcon,
  CAD: CanadaFlagIcon,
}

/** The currencies offered in the picker, each paired with its flag icon. */
export const currencies = CURRENCY_OPTIONS.map((option) => ({
  ...option,
  flag: currencyFlags[option.code],
}))

export type CurrencyChoice = (typeof currencies)[number]
